import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  plant = 1,
  animal,
}

export const getTaskList = createAsyncThunk(
  'HiyaFarm2022/getTaskList',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_job_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getTaskReward = createAsyncThunk(
  'HiyaFarm2022/getTaskReward',
  async (p: {job_id: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_job_reward', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getWarehouseInfo = createAsyncThunk(
  'HiyaFarm2022/getWarehouseInfo',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_storehouse_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getRankList = createAsyncThunk(
  'HiyaFarm2022/getRankList',
  async (p: {type: 1 | 2}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getFriendList = createAsyncThunk(
  'HiyaFarm2022/getFriendList',
  async (
    p: {
      page_num: number
      tab_type: PageTypeEnum
    },
    store: any
  ) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_friends_list', {
      ...store.getState().env.deviceinfo,
      tab_type: p.tab_type,
      page_num: p.page_num,
      page_size: 20,
    })
    return resp.data
  }
)

export const getRevengeList = createAsyncThunk(
  'HiyaFarm2022/getRevengeList',
  async (
    p: {
      page_num: number
      tab_type: PageTypeEnum
    },
    store: any
  ) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_revenge_list', {
      ...store.getState().env.deviceinfo,
      tab_type: p.tab_type,
      page_num: p.page_num,
      page_size: 20,
    })
    return resp.data
  }
)

export const getFactoryInfo = createAsyncThunk(
  'HiyaFarm2022/getFactoryInfo',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_factory_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const composeFactory = createAsyncThunk(
  'HiyaFarm2022/composeFactory',
  async (
    p: {
      compose_map: {[key: number]: number}
    },
    store: any
  ) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_factory_compose', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const buyGoods = createAsyncThunk(
  'HiyaFarm2022/buyGoods',
  async (p: {goods_id: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_shop_buy', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getShopGoodsList = createAsyncThunk(
  'HiyaFarm2022/getShopGoodsList',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_shop_goods_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getLottery = createAsyncThunk(
  'HiyaFarm2022/getLottery',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_lottery', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const getLotteryList = createAsyncThunk(
  'HiyaFarm2022/getLotteryList',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/farm_lottery_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 圣诞节活动任务列表和奖励列表 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27710700
// export const ch_job_list = createAsyncThunk(
//   'ch_job_list',
//   async (arg, store: any) => {
//     const resp = await http.post<
//       HiyaRes<
//         Pick<
//           InitialStateType,
//           | 'job_list'
//           | 'item_list'
//           | 'star_gift_list'
//           | 'count_down'
//           | 'progress'
//           | 'progress_total'
//         >
//       >
//     >('/live/activity/ch_job_list', {
//       ...store.getState().env.deviceinfo,
//     })
//     return resp.data.data
//   }
// )
export enum LandStatusEnum {
  未解锁 = 0,
  未种植,
  可浇水,
  可收获,
}

export enum canteenStatusEnum {
  不可浇水 = 0,
  可浇水,
  可收获果实,
}
export enum waterCollectStatusEnum {
  不可收集 = 0,
  可收集,
  到达上限,
}
export enum taskEnum {
  当前无任务 = 0,
  国王任务 = 1,
  限时pk,
}

// 农场主页信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38779806
export const farm_homepage = createAsyncThunk(
  'HiyaFarm2022_farm_homepage',
  async (arg: {visit_mid?: number; tab_type: PageTypeEnum}, store: any) => {
    const {deviceinfo} = store.getState().env
    const {h_m} = deviceinfo
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'mid'>>>(
      // '/live/activity/holi_list',
      '/live/activity/farm_homepage',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
        visit_mid: arg.visit_mid || h_m,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 国王任务/限时pk信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38779517
export const farm_task = createAsyncThunk(
  'HiyaFarm2022_farm_task',
  async (arg: {is_again: boolean}, store: any) => {
    const resp = await http.post<
      HiyaRes<{status: number; type: number; err_msg: string}>
    >(
      '/live/activity/farm_task',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 收获果实 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38780595
export const farm_harvest = createAsyncThunk(
  'HiyaFarm2022_farm_harvest',
  async (
    arg: {land_id?: number; harvest_all_flag?: boolean; tab_type: PageTypeEnum},
    store: any
  ) => {
    const {taskType, tab_type} = store.getState().HiyaFarm2022
    const {dispatch} = store
    const resp = await http.post<HiyaRes<{left_num: number; err_msg: string}>>(
      '/live/activity/farm_harvest',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    if (taskType === taskEnum.国王任务) {
      // 收获的话如果是国王任务的话需要再次拉取一下任务信息
      dispatch(farm_task({is_again: false}))
    }
    // 收成之后需要拉取一下主页面
    dispatch(farm_homepage({tab_type}))
    return resp.data.data
  }
)

// 收获水  https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38780608
export const farm_collect_water = createAsyncThunk(
  'HiyaFarm2022_farm_collect_water',
  async (arg: {tab_type: PageTypeEnum}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        canteen_info: {
          left_num: number
          left_times: number
          title: string
          status: canteenStatusEnum
        }
        water_collect: {
          product_num: number
          time_left: number
          status: waterCollectStatusEnum
        }
        status: 0 | 1
        err_msg: string
      }>
    >(
      '/live/activity/farm_collect_water',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export enum wateringStatusEnum {
  成功 = 0,
  水不足,
  需要先收果实,
}
// 浇水 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38780579
export const farm_watering = createAsyncThunk(
  'HiyaFarm2022_farm_watering',
  async (
    arg: {land_id?: number; water_all_flag?: boolean; tab_type: PageTypeEnum},
    store: any
  ) => {
    const {taskType} = store.getState().HiyaFarm2022
    const {dispatch} = store
    const resp = await http.post<
      HiyaRes<{status: wateringStatusEnum; err_msg: string}>
    >('/live/activity/farm_watering', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    if (taskType === taskEnum.限时pk) {
      // 浇水的话如果是PK任务的话需要再次拉取一下任务信息
      dispatch(farm_task({is_again: false}))
    }
    return resp.data.data
  }
)
// 偷取水滴 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38776467
export const farm_steal_water = createAsyncThunk(
  'HiyaFarm2022_farm_steal_water',
  async (arg: {target_mid: number; tab_type: PageTypeEnum}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post<
      HiyaRes<{status: number; water: number; err_msg: string}>
    >('/live/activity/farm_steal_water', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 使用道具 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38780342

export const farm_use_props = createAsyncThunk(
  'HiyaFarm2022_farm_use_props',
  async (
    arg: {props_id: number; plant_id?: number; tab_type: PageTypeEnum},
    store: any
  ) => {
    const resp = await http.post<HiyaRes<{status: number; err_msg: string}>>(
      '/live/activity/farm_use_props',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 国王任务补充道具 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38780899
export const farm_task_buy = createAsyncThunk(
  'HiyaFarm2022_farm_task_buy',
  async (arg: {id: number; is_buy: boolean}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post<
      // 0 购买成功 1  金币不足 2 购买失败
      HiyaRes<{status: number; coin: number; err_msg: string}>
    >('/live/activity/farm_task_buy', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 国王任务/限时pk领取奖励接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38779522
export const farm_task_reward = createAsyncThunk(
  'HiyaFarm2022_farm_task_reward',
  async (arg: {id: number}, store: any) => {
    const resp = await http.post<
      // 0 领取成功 1 已领取过 2 领取失败
      HiyaRes<{status: number; err_msg: string}>
    >('/live/activity/farm_task_reward', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
interface HiyaRes<T> {
  ret: number
  data: T
}
export interface landType {
  id: number
  status: LandStatusEnum
  plant_id: number
  plant_icon: string
  corps_name?: string
  corps_icon?: string
  gain_crops?: number
  water_need: number
  unlock_level: number
  unlock_crops_need: number
}
export interface baseType {
  member: {
    id: number
    name: string
    zy_id: string
    avatar: string
  }
  level: number
  // 等级产量，只有当upgrde_need为0的时候才会用到
  level_crops_need: number
  crop_num: number
  upgrade_need: number
  upgrade_reward_flag: boolean
}
export interface canteenType {
  left_num: number
  left_times: number
  title: string
  status: canteenStatusEnum
}
interface InitialStateType {
  water_speed: number
  is_speed_up: boolean // 加速卡是否生效中
  // 道具类型:1: 种子;2:加速卡;3:水滴; 4:镰刀;5:动物幼崽
  props_list: {
    type: 1 | 2 | 3 | 4 | 5
    id: number
    name: string
    icon: string
    num: number
  }[]
  crop_list: {
    id: number
    name: string
    icon: string
    num: number
  }[]
  shopGoodsList: {
    goods_id: number
    icon: string
    name: string
    desc: string
    limit_flag: boolean // 是否限购
    limit_num: number // 初始限购数量
    left_num: number // 剩余限购次数
    type: 1 | 2 | 3 | 4 // 1 种子， 2 加速卡， 3水滴，4镰刀
    coins_cost: number // 单价
  }[]
  // 农场主页信息
  mid?: number
  tab_type?: PageTypeEnum
  base_info?: baseType
  land_info?: Array<landType>
  canteen_info?: canteenType
  water_add?: number
  water_collect?: {
    product_num: number
    time_left: number
    status: waterCollectStatusEnum
  }
  // 每日任务是否有任务完成未领取奖励的红点标示; true:有
  job_reddot_flag?: boolean
  // 好友是否可被偷取的标示
  friend_attack_flag?: boolean
  // 仓库是否存在红点
  store_reddot_flag?: boolean
  attack_random_mid?: number
  attack_times?: Array<number>
  // 养殖场状态
  nurture_info?: {
    // 状态:0:未开放;1:已开放
    status: 0 | 1
    open_day: string
  }
  // 是否有引导页
  new_guide_flag?: boolean
  // 国王任务和PK任务
  id?: number
  taskType?: taskEnum
  // PK  再来一局时 0 成功 1 当日pk已达上限
  taskStatus?: 0 | 1
  // 国王任务
  task_list?: Array<{pic: string; value: number}>
  task_process_list?: Array<{pic: string; value: number}>
  coin?: number
  count_down?: number
  // 奖励内容
  task_reward?: string
  // 奖励图片
  pic?: string
  // PK 任务
  pk_process?: number
  name?: string
  avatar?: string
  reward?: number
  pk_other_process?: number
  other_avatar?: string
  other_name?: string
  other_reward?: number
  total_reward?: number
  // 	浇水次数
  pk_water_times?: number
  // 对手浇水次数
  other_pk_water_times?: number
}

const initialState: InitialStateType = {
  props_list: [],
  crop_list: [],
  water_speed: 0,
  shopGoodsList: [],
  is_speed_up: false,
  tab_type: PageTypeEnum.animal,
}
export const HiyaFarm2022Slice = createSlice({
  name: 'HiyaFarm2022',
  initialState,
  reducers: {
    clearTask: (state, action) => {
      Object.assign(state, {
        taskType: taskEnum.当前无任务,
      })
    },
    // 红点逻辑完全交给后端
    // clearRedDot: (state, action) => {
    //   const {key} = action.payload
    //   Object.assign(state, {
    //     [key]: false,
    //   })
    // },
    changeType: (
      state,
      action: PayloadAction<{
        tab_type: PageTypeEnum
      }>
    ) => {
      const {tab_type} = action.payload
      Object.assign(state, {
        tab_type,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWarehouseInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getShopGoodsList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {shopGoodsList: data.list || []})
    })
    builder.addCase(farm_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(farm_task.fulfilled, (state, action) => {
      const {type, status, ...rest} = action.payload
      const ret = {
        taskType: type,
        taskStatus: status,
      }
      Object.assign(state, ret, rest)
    })

    builder.addCase(farm_collect_water.fulfilled, (state, action) => {
      const {canteen_info} = state
      const {water_collect} = action.payload
      Object.assign(state, {
        water_add: action.payload.canteen_info.left_num - canteen_info.left_num,
        canteen_info: action.payload.canteen_info,
        water_collect,
      })
    })
  },
})
export default HiyaFarm2022Slice.reducer
export const HiyaFarm2022Actions = HiyaFarm2022Slice.actions
